const Dashboard = () => import("@/app/views/app/dashboard/dashboard.vue");

export const dashboardRoutes = [
    {
        component: Dashboard,
        name: "dashboard_dashboard",
        path: "domov"
    },
];